import { useState, useEffect } from "react";
import CountriesMap from "../Profile/CountriesMap";
import { 
    TextField, 
    Typography, 
    Checkbox, 
    FormControlLabel, 
    Grid, 
    MenuItem, 
    FormControl, 
    InputLabel, 
    Select, 
    OutlinedInput, 
    FormHelperText 
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import axiosInstance from "../utils/axiosConfig";
import { useForm, Controller } from "react-hook-form";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import Button from "../Input/Button";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundImage: 'linear-gradient(to bottom, #3f51b5, #ffffff)',
        overflow: 'hidden', // Prevent scrolling
    },
    rootWithModal: {
        backgroundColor: '#ffffff', // White background when modal is open
    },
    contentArea: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: theme.spacing(1, 0), // Reduced padding for better space utilization
    },
    registrationContainer: {
        width: '480px', // Slightly reduced width for better proportions
        maxWidth: '85%', // Slightly reduced max width
        backgroundColor: '#FF6419', // Keep the original orange background
        boxShadow: theme.shadows[5],
        padding: theme.spacing(1.5, 3.5, 1.5), // Further reduced padding for better fit
        borderRadius: 12,
        outline: 'none',
    },
    title: {
        color: '#B4FA64', // Keep the original green text
        textAlign: 'center',
        padding: '12px 24px', // Further reduced vertical padding for better proportions
        fontSize: 30,
        fontFamily: 'NeueHassDisplayMedium',
    },
    input: {
        '& .MuiOutlinedInput-root': {
            background: 'white',
            fontFamily: 'NeueHassDisplayMedium',
            borderRadius: 16,
        },
    },
    formControl: {
        width: '100%',
        '& .MuiOutlinedInput-root': {
            background: 'white',
            fontFamily: 'NeueHassDisplayMedium',
            borderRadius: 16,
        },
    },
    hiddenLabel: {
        display: 'none'
    },
    placeholderSelect: {
        color: 'rgba(0, 0, 0, 0.6)', // Match placeholder color
        fontWeight: 300, // Lighter weight to match placeholders
    },
    submitButton: {
        width: '80%',
        textTransform: 'capitalize',
        backgroundColor: '#B4FA64',
        color: '#FF6419',
        '& .MuiButton-label': {
            fontSize: '19px',
        },
        borderRadius: '24px',
        fontFamily: 'NeueHassDisplayRoman',
    },
    checkboxContainer: {
        paddingTop: 20,
        '& .MuiTypography-root': {
            color: '#B4FA64', // Keep the original green text
        },
        '& .MuiCheckbox-root': {
            color: '#B4FA64', // Keep the original green checkbox
        },
    },
    footer: {
        backgroundColor: '#b4fa64',
        width: '100%',
        padding: theme.spacing(2.5), // Increased padding to be closer to original
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        alignItems: 'center',
    },
    footerLink: {
        color: '#ff6419',
        textDecoration: 'underline',
        marginRight: theme.spacing(2.5),
        marginLeft: theme.spacing(2.5),
        marginBottom: theme.spacing(1),
        fontSize: '24px', // Increased font size closer to original (was 28px)
        fontWeight: 900,
        fontFamily: '"Lato", "NeueHaasGroteskDisplay Pro", Arial, sans-serif',
        '&:hover': {
            textDecoration: 'underline'
        }
    },
}));



export default function ProductionRegistration(props) {
    const classes = useStyles();
    const { control: registerControl, register: registerForm, handleSubmit: handleSubmitRegister } = useForm();
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const history = useHistory();
    const { setUser, user } = props; // eslint-disable-line no-unused-vars
    
    const [, setCountrySelected] = useState(false); // eslint-disable-line no-unused-vars
    const [, setGenderSelected] = useState(false); // eslint-disable-line no-unused-vars
    const [successfulRegistration, setSuccessfulRegistration] = useState(false);
    
    // Check if this is a registration request
    const isRegistrationRequest = searchParams.get("register-new-user") === "true";
    
    useEffect(() => {
        if (successfulRegistration) {
            setTimeout(() => {
                alert(`Thank you for joining BridgePal Kids. A verification and permission email has been sent to your parent/guardian.\n\nYou will be able to access your account after parental verification.`);
                // Redirect back to WIX after successful registration
                window.location.replace('https://www.bridgepalkids.com/');
            }, 1000);
        }
    }, [successfulRegistration]);
    
    const onSubmitRegisterKid = async (data) => {
        console.log("🚀 ~ file: ProductionRegistration.jsx ~ onSubmitRegisterKid ~ data:", {data});
        try {
            const axiosResponse = await axiosInstance.post("/auth/register", data);
            if (axiosResponse.status === 200 || axiosResponse.status === 201) {
                console.log("🚀 ~ file: ProductionRegistration.jsx ~ onSubmitRegisterKid ~ Registration Successful!");
                setSuccessfulRegistration(true);
                history.push("/");
            };
        } catch (error) {
            alert("Unsuccessful registration");
            console.error("Registration error:", error);
            if (error.response) {
                // The request was made and the server responded with a status code that falls out of the range of 2xx
                console.error("Error Response:", error.response);
                alert(error.response.data.message || "Registration failed. Please try again.");
            } else if (error.request) {
                // The request was made but no response was received
                console.error("No response received:", error.request);
                alert("No response from server. Please check your internet connection and try again.");
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error("Error message:", error.message);
                alert("An error occurred. Please try again.");
            }
        }
    };
    
    // If user is already authenticated, redirect to dashboard
    if (user) return <Redirect to="/dashboard/home" />;
    
    // If this is not a registration request, redirect to WIX
    if (!isRegistrationRequest) {
        window.location.replace('https://www.bridgepalkids.com/');
        return null;
    }
    
    return (
        <div className={`${classes.root} ${classes.rootWithModal}`}>
            <div className={classes.contentArea}>
                <div className={classes.registrationContainer}>
                <Typography variant="h5" className={classes.title}>
                    Sign-Up
                </Typography>
                
                <form id="registration-form" onSubmit={handleSubmitRegister(onSubmitRegisterKid)}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                placeholder="Kid's First Name"
                                fullWidth
                                {...registerForm("name")}
                                variant="outlined"
                                className={classes.input}
                            />
                        </Grid>
                        
                        <Grid item xs={6}>
                            <Controller
                                control={registerControl}
                                name="country"
                                defaultValue=""
                                rules={{ required: true }}
                                render={({ field, fieldState: { error } }) => {
                                    const { onChange, value } = field;
                                    
                                    const handleSelectChange = (e) => {
                                        onChange(e);
                                        setCountrySelected(true);
                                    };
                                    
                                    const handleOpen = () => setCountrySelected(true);
                                    
                                    return (
                                        <FormControl variant="outlined" className={classes.formControl} error={!!error}>
                                            <InputLabel 
                                                shrink={true} 
                                                className={classes.hiddenLabel}
                                            >
                                                Country
                                            </InputLabel>
                                            <Select
                                                value={value || ''}
                                                onChange={handleSelectChange}
                                                onOpen={handleOpen}
                                                displayEmpty
                                                renderValue={(selected) => (
                                                    <span className={!selected ? classes.placeholderSelect : ''}>
                                                        {selected ? CountriesMap[selected] : 'Country'}
                                                    </span>
                                                )}
                                                label=""
                                                input={<OutlinedInput notched={false} label="" />}
                                            >
                                                {Object.entries(CountriesMap).map(([code, name]) => (
                                                    <MenuItem key={code} value={code}>
                                                        {name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            {error && <FormHelperText>Country is required</FormHelperText>}
                                        </FormControl>
                                    );
                                }}
                            />
                        </Grid>
                        
                        <Grid item xs={6}>
                            <Controller
                                control={registerControl}
                                name="dob"
                                defaultValue={null}
                                render={({ field: { onChange, value }, fieldState: { error } }) => (
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="EN-US">
                                        <DatePicker
                                            value={value}
                                            onChange={onChange}
                                            slotProps={{
                                                textField: {
                                                    placeholder: "Kid's DOB",
                                                    fullWidth: true,
                                                    error: !!error,
                                                    helperText: error?.message,
                                                    className: classes.input
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                )}
                            />
                        </Grid>
                        
                        <Grid item xs={6}>
                            <Controller
                                control={registerControl}
                                name="gender"
                                defaultValue=""
                                rules={{ required: true }}
                                render={({ field, fieldState: { error } }) => {
                                    const { onChange, value } = field;
                                    
                                    const handleSelectChange = (e) => {
                                        onChange(e);
                                        setGenderSelected(true);
                                    };
                                    
                                    const handleOpen = () => setGenderSelected(true);
                                    
                                    return (
                                        <FormControl variant="outlined" className={classes.formControl} error={!!error}>
                                            <InputLabel 
                                                shrink={true} 
                                                className={classes.hiddenLabel}
                                            >
                                                Gender
                                            </InputLabel>
                                            <Select
                                                value={value || ''}
                                                onChange={handleSelectChange}
                                                onOpen={handleOpen}
                                                displayEmpty
                                                renderValue={(selected) => (
                                                    <span className={!selected ? classes.placeholderSelect : ''}>
                                                        {selected === 'M' ? 'Male' : selected === 'F' ? 'Female' : 'Gender'}
                                                    </span>
                                                )}
                                                label=""
                                                input={<OutlinedInput notched={false} label="" />}
                                            >
                                                <MenuItem value="M">Male</MenuItem>
                                                <MenuItem value="F">Female</MenuItem>
                                            </Select>
                                            {error && <FormHelperText>Gender is required</FormHelperText>}
                                        </FormControl>
                                    );
                                }}
                            />
                        </Grid>
                        
                        <Grid item xs={12}>
                            <TextField
                                placeholder="Kid's Username"
                                variant="outlined"
                                fullWidth
                                {...registerForm("username")}
                                className={classes.input}
                            />
                        </Grid>
                        
                        <Grid item xs={12}>
                            <TextField
                                placeholder="Kid's Password"
                                variant="outlined"
                                fullWidth
                                type="password"
                                {...registerForm("password")}
                                className={classes.input}
                            />
                        </Grid>
                        
                        <Grid item xs={12}>
                            <TextField
                                placeholder="Parent's Email Address"
                                variant="outlined"
                                fullWidth
                                {...registerForm("email")}
                                className={classes.input}
                            />
                        </Grid>
                        
                        <Grid item xs={12} className={classes.checkboxContainer}>
                            <FormControlLabel
                                control={<Checkbox {...registerForm("rememberMe")} />}
                                label="Remember Me"
                            />
                        </Grid>
                        
                        <Grid item xs={12} style={{ textAlign: 'center' }}>
                            <Button
                                className={classes.submitButton}
                                type="submit"
                                onClick={handleSubmitRegister(onSubmitRegisterKid)}
                            >
                                Create Account
                            </Button>
                        </Grid>
                    </Grid>
                </form>
                </div>
            </div>
            
            <footer className={classes.footer}>
                <a href="https://xcbrgpal.com" className={classes.footerLink}>BridgePal Website</a>
                <a href="https://bridgepalkids.com/terms" className={classes.footerLink}>BridgePal Terms of Use</a>
                <a href="https://bridgepalkids.com/privacy-policy" className={classes.footerLink}>BridgePal Privacy Policy</a>
                <a href="https://bridgepalkids.com/kids-privacy-policy" className={classes.footerLink}>BridgePal Kids Privacy</a>
            </footer>
        </div>
    );
}